@for (_ of gridColumns; track i; let i = $index) {
  <div class="gridster-column" [ngStyle]="gridRenderer.getGridColumnStyle(i)"></div>
}
@for (_ of gridRows; track i; let i = $index) {
  <div class="gridster-row" [ngStyle]="gridRenderer.getGridRowStyle(i)"></div>
}
<ng-content />

<gridster-preview class="gridster-preview" />
